export default {
  dataIterator: {
    rowsPerPageText: 'รายการต่อหน้า:',
    rowsPerPageAll: 'ทั้งหมด',
    pageText: '{0}-{1} จาก {2}',
    noResultsText: 'ไม่พบข้อมูลที่ค้นหา',
    nextPage: 'หน้าต่อไป',
    prevPage: 'หน้าที่แล้ว'
  },
  dataTable: {
    rowsPerPageText: 'แถวต่อหน้า:'
  },
  noDataText: 'ไม่มีข้อมูล',
  carousel: {
    prev: 'ภาพก่อนหน้า',
    next: 'ภาพต่อไป'
  }
}
